import api from "@/api/api";

export const getStudents = ({ folderId, limit = 1000 }) => {
  const params = {
    limit,
  };

  if (folderId) {
    params.folderId = folderId;
  }

  return api.get("/students", { params });
};

export const createStudent = ({ firstName, lastName }) =>
  api.post("/students", { firstName, lastName });

export const attachStudentToEssay = ({ essayId, studentId }) =>
  api.patch(`/essays/${essayId}`, { StudentId: studentId });

export const updateStudent = ({ studentId, firstName, lastName }) =>
  api.patch(`/students/${studentId}`, { firstName, lastName });

export const detachStudentFromEssay = ({ studentId, essayId }) =>
  api.delete(`/students/${studentId}/essays/${essayId}`);

export const deleteStudent = ({ studentId }) =>
  api.delete(`/students/${studentId}`);
